import { dispatch } from "../store/store";
import {
  getServiceByPostCodeData,
  setServiceByPostCodeLoadingData,
} from "../features/DOSSlice/DOSSlice";
import { logErrorWithPayload } from "../services/logService";

const reducerName = "dosSlice";

// #region State Setters
export const setServiceByPostCodeLoading = (isLoading) => {
  dispatch(setServiceByPostCodeLoadingData(isLoading));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers

export const getServiceByPostCode = async (data) => {
  let result = null;
  try {
    result = await dispatch(getServiceByPostCodeData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
